import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { type RouteItem } from './server/getRoutes';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function helperSearch(
    query: string,
    node: RouteItem,
    prefix: string,
    currenLevel: number,
    maxLevel?: number
) {
    const res: RouteItem[] = [];
    let parentHas = false;

    const nextLink = `${prefix}${node.href}`;
    if (!node.noLink && node.title.toLowerCase().includes(query.toLowerCase())) {
        res.push({ ...node, items: undefined, href: nextLink });
        parentHas = true;
    }
    const goNext = maxLevel ? currenLevel < maxLevel : true;
    if (goNext) {
        node.items?.forEach((item) => {
            const innerRes = helperSearch(query, item, nextLink, currenLevel + 1, maxLevel);
            if (!!innerRes.length && !parentHas && !node.noLink) {
                res.push({ ...node, items: undefined, href: nextLink });
                parentHas = true;
            }
            res.push(...innerRes);
        });
    }
    return res;
}

// export function advanceSearch(query: string) {
// 	return getRoutes()
// 		.map((node) =>
// 			helperSearch(query, node, "", 1, query.length == 0 ? 2 : undefined)
// 		)
// 		.flat();
// }

// Thursday, May 23, 2024
export function formatDate(dateStr: string): string {
    const date = new Date(dateStr);

    return new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false, // 24小时制
    }).format(date);
}

export function stringToTimeStamp(dateStr: string) {
    // const date = new Date(dateStr);
    // const [day, month, year] = date.split('-').map(Number);
    // return new Date(year, month - 1, day);
    return new Date(dateStr).getTime();
}

// https://devicon.dev/
//  icon format : <i class="devicon-go-plain"></i>
export const fileExtensionIconMap = {
    js: 'javascript',
    ts: 'typescript',
    jsx: 'react',
    tsx: 'react',
    java: 'java',
    css: 'css3',
    md: 'markdown',
    mdx: 'markdown',
    go: 'go',
    astro: 'astro',
    prisma: 'prisma',
    py: 'python',
    kt: 'kotlin',
    php: 'php',
    gitignore: 'git',
    cs: 'csharp',
    cpp: 'cplusplus',
    c: 'c',
    bash: 'bash',
    html: 'html5',
};

export function hasSupportedExtension(name: string) {
    const splittedNames = name.split('.');
    const ext = splittedNames[splittedNames.length - 1];
    if (!ext) return false;
    return !!fileExtensionIconMap[ext as keyof typeof fileExtensionIconMap];
}

export function getIconName(name: string) {
    const splittedNames = name.split('.');
    const ext = splittedNames[splittedNames.length - 1];
    return fileExtensionIconMap[ext as keyof typeof fileExtensionIconMap];
}
